module.exports = function (THREE) {
  return (function () {
    function q(aC) {
      THREE.Loader.call(this, aC);
      this.dracoLoader = null;
      this.ddsLoader = null;
      this.pluginCallbacks = [];
      this.register(function (aD) {
        return new Y(aD);
      });
    }
    function J() {
      var aC = {};
      return {
        get: function (aD) {
          return aC[aD];
        },
        add: function (aD, aE) {
          aC[aD] = aE;
        },
        remove: function (aD) {
          delete aC[aD];
        },
        removeAll: function () {
          aC = {};
        },
      };
    }
    function K(aC) {
      if (!aC) {
        throw new Error(
          "THREE.GLTFLoader: Attempting to load .dds texture without importing THREE.DDSLoader",
        );
      }
      this.name = ah.MSFT_TEXTURE_DDS;
      this.ddsLoader = aC;
    }
    function Q(aC) {
      this.name = ah.KHR_LIGHTS_PUNCTUAL;
      var aD = (aC.extensions && aC.extensions[ah.KHR_LIGHTS_PUNCTUAL]) || {};
      this.lightDefs = aD.lights || [];
    }
    function X() {
      this.name = ah.KHR_MATERIALS_UNLIT;
    }
    function Y(aC) {
      this.parser = aC;
      this.name = ah.KHR_MATERIALS_CLEARCOAT;
    }
    function Z(aC) {
      this.name = ah.KHR_BINARY_GLTF;
      this.content = null;
      this.body = null;
      var aD = new DataView(aC, 0, 12);
      this.header = {
        magic: THREE.LoaderUtils.decodeText(new Uint8Array(aC.slice(0, 4))),
        version: aD.getUint32(4, true),
        length: aD.getUint32(8, true),
      };
      if (this.header.magic !== "glTF") {
        throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
      }
      if (this.header.version < 2) {
        throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
      }
      var aE;
      for (var aF = new DataView(aC, 12), aG = 0; aG < aF.byteLength; ) {
        aE = aF.getUint32(aG, true);
        aG += 4;
        var aH = aF.getUint32(aG, true);
        aG += 4;
        if (aH === aj.JSON) {
          var aI = new Uint8Array(aC, 12 + aG, aE);
          this.content = THREE.LoaderUtils.decodeText(aI);
        } else if (aH === aj.BIN) {
          var aJ = 12 + aG;
          this.body = aC.slice(aJ, aJ + aE);
        }
        aG += aE;
      }
      if (this.content === null) {
        throw new Error("THREE.GLTFLoader: JSON content not found.");
      }
    }
    function a0(aC, aD) {
      if (!aD) {
        throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
      }
      this.name = ah.KHR_DRACO_MESH_COMPRESSION;
      this.json = aC;
      this.dracoLoader = aD;
      this.dracoLoader.preload();
    }
    function a1() {
      this.name = ah.KHR_TEXTURE_TRANSFORM;
    }
    function a2(aC) {
      THREE.MeshStandardMaterial.call(this);
      this.isGLTFSpecularGlossinessMaterial = true;
      var aD = {
        specular: {
          value: new THREE.Color().setHex(16777215),
        },
        glossiness: {
          value: 1,
        },
        specularMap: {
          value: null,
        },
        glossinessMap: {
          value: null,
        },
      };
      this._extraUniforms = aD;
      this.onBeforeCompile = function (aE) {
        for (var aF in aD) {
          aE.uniforms[aF] = aD[aF];
        }
        aE.fragmentShader = aE.fragmentShader.replace(
          "uniform float roughness;",
          "uniform vec3 specular;",
        );
        aE.fragmentShader = aE.fragmentShader.replace(
          "uniform float metalness;",
          "uniform float glossiness;",
        );
        aE.fragmentShader = aE.fragmentShader.replace(
          "#include <roughnessmap_pars_fragment>",
          "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
        );
        aE.fragmentShader = aE.fragmentShader.replace(
          "#include <metalnessmap_pars_fragment>",
          "#ifdef USE_GLOSSINESSMAP\n\tuniform sampler2D glossinessMap;\n#endif",
        );
        aE.fragmentShader = aE.fragmentShader.replace(
          "#include <roughnessmap_fragment>",
          "vec3 specularFactor = specular;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\ttexelSpecular = sRGBToLinear( texelSpecular );\n\t// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture\n\tspecularFactor *= texelSpecular.rgb;\n#endif",
        );
        aE.fragmentShader = aE.fragmentShader.replace(
          "#include <metalnessmap_fragment>",
          "float glossinessFactor = glossiness;\n#ifdef USE_GLOSSINESSMAP\n\tvec4 texelGlossiness = texture2D( glossinessMap, vUv );\n\t// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture\n\tglossinessFactor *= texelGlossiness.a;\n#endif",
        );
        aE.fragmentShader = aE.fragmentShader.replace(
          "#include <lights_physical_fragment>",
          "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( 1.0 - glossinessFactor, 0.0525 );// 0.0525 corresponds to the base mip of a 256 cubemap.\nmaterial.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\nmaterial.specularColor = specularFactor.rgb;",
        );
      };
      Object.defineProperties(this, {
        specular: {
          get: function () {
            return aD.specular.value;
          },
          set: function (aE) {
            aD.specular.value = aE;
          },
        },
        specularMap: {
          get: function () {
            return aD.specularMap.value;
          },
          set: function (aE) {
            aD.specularMap.value = aE;
          },
        },
        glossiness: {
          get: function () {
            return aD.glossiness.value;
          },
          set: function (aE) {
            aD.glossiness.value = aE;
          },
        },
        glossinessMap: {
          get: function () {
            return aD.glossinessMap.value;
          },
          set: function (aE) {
            aD.glossinessMap.value = aE;
            if (aE) {
              this.defines.USE_GLOSSINESSMAP = "";
              this.defines.USE_ROUGHNESSMAP = "";
            } else {
              delete this.defines.USE_ROUGHNESSMAP;
              delete this.defines.USE_GLOSSINESSMAP;
            }
          },
        },
      });
      delete this.metalness;
      delete this.roughness;
      delete this.metalnessMap;
      delete this.roughnessMap;
      this.setValues(aC);
    }
    function a3() {
      return {
        name: ah.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS,
        specularGlossinessParams: [
          "color",
          "map",
          "lightMap",
          "lightMapIntensity",
          "aoMap",
          "aoMapIntensity",
          "emissive",
          "emissiveIntensity",
          "emissiveMap",
          "bumpMap",
          "bumpScale",
          "normalMap",
          "normalMapType",
          "displacementMap",
          "displacementScale",
          "displacementBias",
          "specularMap",
          "specular",
          "glossinessMap",
          "glossiness",
          "alphaMap",
          "envMap",
          "envMapIntensity",
          "refractionRatio",
        ],
        getMaterialType: function () {
          return a2;
        },
        extendParams: function (aC, aD, aE) {
          var aF = aD.extensions[this.name];
          aC.color = new THREE.Color(1, 1, 1);
          aC.opacity = 1;
          var aG = [];
          if (Array.isArray(aF.diffuseFactor)) {
            var aH = aF.diffuseFactor;
            aC.color.fromArray(aH);
            aC.opacity = aH[3];
          }
          if (aF.diffuseTexture !== undefined) {
            aG.push(aE.assignTexture(aC, "map", aF.diffuseTexture));
          }
          aC.emissive = new THREE.Color(0, 0, 0);
          aC.glossiness =
            aF.glossinessFactor === undefined ? 1 : aF.glossinessFactor;
          aC.specular = new THREE.Color(1, 1, 1);
          if (Array.isArray(aF.specularFactor)) {
            aC.specular.fromArray(aF.specularFactor);
          }
          if (aF.specularGlossinessTexture !== undefined) {
            var aI = aF.specularGlossinessTexture;
            aG.push(aE.assignTexture(aC, "glossinessMap", aI));
            aG.push(aE.assignTexture(aC, "specularMap", aI));
          }
          return Promise.all(aG);
        },
        createMaterial: function (aC) {
          var aD = new a2(aC);
          aD.fog = true;
          aD.color = aC.color;
          aD.map = aC.map === undefined ? null : aC.map;
          aD.lightMap = null;
          aD.lightMapIntensity = 1;
          aD.aoMap = aC.aoMap === undefined ? null : aC.aoMap;
          aD.aoMapIntensity = 1;
          aD.emissive = aC.emissive;
          aD.emissiveIntensity = 1;
          aD.emissiveMap = aC.emissiveMap === undefined ? null : aC.emissiveMap;
          aD.bumpMap = aC.bumpMap === undefined ? null : aC.bumpMap;
          aD.bumpScale = 1;
          aD.normalMap = aC.normalMap === undefined ? null : aC.normalMap;
          aD.normalMapType = THREE.TangentSpaceNormalMap;
          if (aC.normalScale) {
            aD.normalScale = aC.normalScale;
          }
          aD.displacementMap = null;
          aD.displacementScale = 1;
          aD.displacementBias = 0;
          aD.specularMap = aC.specularMap === undefined ? null : aC.specularMap;
          aD.specular = aC.specular;
          aD.glossinessMap =
            aC.glossinessMap === undefined ? null : aC.glossinessMap;
          aD.glossiness = aC.glossiness;
          aD.alphaMap = null;
          aD.envMap = aC.envMap === undefined ? null : aC.envMap;
          aD.envMapIntensity = 1;
          aD.refractionRatio = 0.98;
          return aD;
        },
      };
    }
    function a4() {
      this.name = ah.KHR_MESH_QUANTIZATION;
    }
    function a5(aC, aD, aE, aF) {
      THREE.Interpolant.call(this, aC, aD, aE, aF);
    }
    function a6(aC, aD) {
      if (typeof aC != "string" || aC === "") {
        return "";
      } else {
        if (/^https?:\/\//i.test(aD) && /^\//.test(aC)) {
          aD = aD.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        }
        if (
          /^(https?:)?\/\//i.test(aC) ||
          /^data:.*,.*$/i.test(aC) ||
          /^blob:.*$/i.test(aC)
        ) {
          return aC;
        } else {
          return aD + aC;
        }
      }
    }
    function a7(aC) {
      if (aC.DefaultMaterial === undefined) {
        aC.DefaultMaterial = new THREE.MeshStandardMaterial({
          color: 16777215,
          emissive: 0,
          metalness: 1,
          roughness: 1,
          transparent: false,
          depthTest: true,
          side: THREE.FrontSide,
        });
      }
      return aC.DefaultMaterial;
    }
    function a8(aC, aD, aE) {
      for (var aF in aE.extensions) {
        if (aC[aF] === undefined) {
          aD.userData.gltfExtensions = aD.userData.gltfExtensions || {};
          aD.userData.gltfExtensions[aF] = aE.extensions[aF];
        }
      }
    }
    function a9(aC, aD) {
      if (aD.extras !== undefined) {
        if (typeof aD.extras == "object") {
          Object.assign(aC.userData, aD.extras);
        } else {
          console.warn(
            "THREE.GLTFLoader: Ignoring primitive type .extras, " + aD.extras,
          );
        }
      }
    }
    function aa(aC, aD) {
      aC.updateMorphTargets();
      if (aD.weights !== undefined) {
        for (var aE = 0, aF = aD.weights.length; aE < aF; aE++) {
          aC.morphTargetInfluences[aE] = aD.weights[aE];
        }
      }
      if (aD.extras && Array.isArray(aD.extras.targetNames)) {
        var aG = aD.extras.targetNames;
        if (aC.morphTargetInfluences.length === aG.length) {
          aC.morphTargetDictionary = {};
          aE = 0;
          aF = aG.length;
          for (; aE < aF; aE++) {
            aC.morphTargetDictionary[aG[aE]] = aE;
          }
        } else {
          console.warn(
            "THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.",
          );
        }
      }
    }
    function ab(aC) {
      var aD = aC.extensions && aC.extensions[ah.KHR_DRACO_MESH_COMPRESSION];
      if (aD) {
        return (
          "draco:" + aD.bufferView + ":" + aD.indices + ":" + ac(aD.attributes)
        );
      } else {
        return aC.indices + ":" + ac(aC.attributes) + ":" + aC.mode;
      }
    }
    function ac(aC) {
      var aD = "";
      var aE = Object.keys(aC).sort();
      for (var aF = 0, aG = aE.length; aF < aG; aF++) {
        aD += aE[aF] + ":" + aC[aE[aF]] + ";";
      }
      return aD;
    }
    function ad(aC, aD) {
      this.json = aC || {};
      this.extensions = {};
      this.plugins = {};
      this.options = aD || {};
      this.cache = new J();
      this.associations = new Map();
      this.primitiveCache = {};
      this.textureLoader =
        typeof createImageBitmap != "undefined" &&
        /Firefox/.test(navigator.userAgent) === false
          ? new THREE.ImageBitmapLoader(this.options.manager)
          : new THREE.TextureLoader(this.options.manager);
      this.textureLoader.setCrossOrigin(this.options.crossOrigin);
      this.fileLoader = new THREE.FileLoader(this.options.manager);
      this.fileLoader.setResponseType("arraybuffer");
      if (this.options.crossOrigin === "use-credentials") {
        this.fileLoader.setWithCredentials(true);
      }
    }
    function ae(aC, aD, aE) {
      var aF = aD.attributes;
      var aG = new THREE.Box3();
      if (aF.POSITION !== undefined) {
        var aH = (aP = aE.json.accessors[aF.POSITION]).min;
        var aI = aP.max;
        if (aH !== undefined && aI !== undefined) {
          aG.set(
            new THREE.Vector3(aH[0], aH[1], aH[2]),
            new THREE.Vector3(aI[0], aI[1], aI[2]),
          );
          var aJ = aD.targets;
          if (aJ !== undefined) {
            var aK;
            var aL = new THREE.Vector3();
            var aM = new THREE.Vector3();
            for (var aN = 0, aO = aJ.length; aN < aO; aN++) {
              if ((aK = aJ[aN]).POSITION !== undefined) {
                var aP;
                aH = (aP = aE.json.accessors[aK.POSITION]).min;
                aI = aP.max;
                if (aH !== undefined && aI !== undefined) {
                  aM.setX(Math.max(Math.abs(aH[0]), Math.abs(aI[0])));
                  aM.setY(Math.max(Math.abs(aH[1]), Math.abs(aI[1])));
                  aM.setZ(Math.max(Math.abs(aH[2]), Math.abs(aI[2])));
                  aL.max(aM);
                } else {
                  console.warn(
                    "THREE.GLTFLoader: Missing min/max properties for accessor POSITION.",
                  );
                }
              }
            }
            aG.expandByVector(aL);
          }
          aC.boundingBox = aG;
          var aQ = new THREE.Sphere();
          aG.getCenter(aQ.center);
          aQ.radius = aG.min.distanceTo(aG.max) / 2;
          aC.boundingSphere = aQ;
        } else {
          console.warn(
            "THREE.GLTFLoader: Missing min/max properties for accessor POSITION.",
          );
        }
      }
    }
    function af(aC, aD, aE) {
      function aF(aL, aM) {
        return aE.getDependency("accessor", aL).then(function (aN) {
          aC.setAttribute(aM, aN);
        });
      }
      var aG = aD.attributes;
      var aH = [];
      for (var aI in aG) {
        var aJ = av[aI] || aI.toLowerCase();
        if (!(aJ in aC.attributes)) {
          aH.push(aF(aG[aI], aJ));
        }
      }
      if (aD.indices !== undefined && !aC.index) {
        var aK = aE.getDependency("accessor", aD.indices).then(function (aL) {
          aC.setIndex(aL);
        });
        aH.push(aK);
      }
      a9(aC, aD);
      ae(aC, aD, aE);
      return Promise.all(aH).then(function () {
        if (aD.targets === undefined) {
          return aC;
        } else {
          return (function (aL, aM, aN) {
            for (
              var aO = false, aP = false, aQ = 0, aR = aM.length;
              aQ < aR &&
              ((aS = aM[aQ]).POSITION !== undefined && (aO = true),
              aS.NORMAL !== undefined && (aP = true),
              !aO || !aP);
              aQ++
            );
            if (!aO && !aP) {
              return Promise.resolve(aL);
            }
            var aS;
            var aT = [];
            var aU = [];
            aQ = 0;
            aR = aM.length;
            for (; aQ < aR; aQ++) {
              aS = aM[aQ];
              if (aO) {
                var aV =
                  aS.POSITION === undefined
                    ? aL.attributes.position
                    : aN.getDependency("accessor", aS.POSITION);
                aT.push(aV);
              }
              if (aP) {
                aV =
                  aS.NORMAL === undefined
                    ? aL.attributes.normal
                    : aN.getDependency("accessor", aS.NORMAL);
                aU.push(aV);
              }
            }
            return Promise.all([Promise.all(aT), Promise.all(aU)]).then(
              function (aW) {
                var aX = aW[0];
                var aY = aW[1];
                if (aO) {
                  aL.morphAttributes.position = aX;
                }
                if (aP) {
                  aL.morphAttributes.normal = aY;
                }
                aL.morphTargetsRelative = true;
                return aL;
              },
            );
          })(aC, aD.targets, aE);
        }
      });
    }
    function ag(aC, aD) {
      var aE = aC.getIndex();
      if (aE === null) {
        var aF = [];
        var aG = aC.getAttribute("position");
        if (aG === undefined) {
          console.error(
            "THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.",
          );
          return aC;
        }
        for (var aH = 0; aH < aG.count; aH++) {
          aF.push(aH);
        }
        aC.setIndex(aF);
        aE = aC.getIndex();
      }
      var aI = aE.count - 2;
      var aJ = [];
      if (aD === THREE.TriangleFanDrawMode) {
        for (aH = 1; aH <= aI; aH++) {
          aJ.push(aE.getX(0));
          aJ.push(aE.getX(aH));
          aJ.push(aE.getX(aH + 1));
        }
      } else {
        for (aH = 0; aH < aI; aH++) {
          if (aH % 2 == 0) {
            aJ.push(aE.getX(aH));
            aJ.push(aE.getX(aH + 1));
            aJ.push(aE.getX(aH + 2));
          } else {
            aJ.push(aE.getX(aH + 2));
            aJ.push(aE.getX(aH + 1));
            aJ.push(aE.getX(aH));
          }
        }
      }
      if (aJ.length / 3 != aI) {
        console.error(
          "THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.",
        );
      }
      var aK = aC.clone();
      aK.setIndex(aJ);
      return aK;
    }
    q.prototype = Object.assign(Object.create(THREE.Loader.prototype), {
      constructor: q,
      load: function (aC, aD, aE, aF) {
        var aG;
        var aH = this;
        aG =
          this.resourcePath === ""
            ? this.path === ""
              ? THREE.LoaderUtils.extractUrlBase(aC)
              : this.path
            : this.resourcePath;
        aH.manager.itemStart(aC);
        function aI(aK) {
          if (aF) {
            aF(aK);
          } else {
            console.error(aK);
          }
          aH.manager.itemError(aC);
          aH.manager.itemEnd(aC);
        }
        var aJ = new THREE.FileLoader(aH.manager);
        aJ.setPath(this.path);
        aJ.setResponseType("arraybuffer");
        aJ.setRequestHeader(this.requestHeader);
        if (aH.crossOrigin === "use-credentials") {
          aJ.setWithCredentials(true);
        }
        aJ.load(
          aC,
          function (aK) {
            try {
              aH.parse(
                aK,
                aG,
                function (aL) {
                  aD(aL);
                  aH.manager.itemEnd(aC);
                },
                aI,
              );
            } catch (aL) {
              aI(aL);
            }
          },
          aE,
          aI,
        );
      },
      setDRACOLoader: function (aC) {
        this.dracoLoader = aC;
        return this;
      },
      setDDSLoader: function (aC) {
        this.ddsLoader = aC;
        return this;
      },
      register: function (aC) {
        if (this.pluginCallbacks.indexOf(aC) === -1) {
          this.pluginCallbacks.push(aC);
        }
        return this;
      },
      unregister: function (aC) {
        if (this.pluginCallbacks.indexOf(aC) !== -1) {
          this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(aC), 1);
        }
        return this;
      },
      parse: function (aC, aD, aE, aF) {
        var aG;
        var aH = {};
        var aI = {};
        if (typeof aC == "string") {
          aG = aC;
        } else if (
          THREE.LoaderUtils.decodeText(new Uint8Array(aC, 0, 4)) === ai
        ) {
          try {
            aH[ah.KHR_BINARY_GLTF] = new Z(aC);
          } catch (aP) {
            if (aF) {
              aF(aP);
            }
            return;
          }
          aG = aH[ah.KHR_BINARY_GLTF].content;
        } else {
          aG = THREE.LoaderUtils.decodeText(new Uint8Array(aC));
        }
        var aJ = JSON.parse(aG);
        if (aJ.asset === undefined || aJ.asset.version[0] < 2) {
          if (aF) {
            aF(
              new Error(
                "THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.",
              ),
            );
          }
        } else {
          var aK = new ad(aJ, {
            path: aD || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            manager: this.manager,
          });
          aK.fileLoader.setRequestHeader(this.requestHeader);
          var aL;
          for (var aM = 0; aM < this.pluginCallbacks.length; aM++) {
            aI[(aL = this.pluginCallbacks[aM](aK)).name] = aL;
            aH[aL.name] = true;
          }
          if (aJ.extensionsUsed) {
            for (aM = 0; aM < aJ.extensionsUsed.length; ++aM) {
              var aN = aJ.extensionsUsed[aM];
              var aO = aJ.extensionsRequired || [];
              if (aN === ah.KHR_LIGHTS_PUNCTUAL) {
                aH[aN] = new Q(aJ);
              } else if (aN === ah.KHR_MATERIALS_UNLIT) {
                aH[aN] = new X();
              } else if (aN === ah.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS) {
                aH[aN] = new a3();
              } else if (aN === ah.KHR_DRACO_MESH_COMPRESSION) {
                aH[aN] = new a0(aJ, this.dracoLoader);
              } else if (aN === ah.MSFT_TEXTURE_DDS) {
                aH[aN] = new K(this.ddsLoader);
              } else if (aN === ah.KHR_TEXTURE_TRANSFORM) {
                aH[aN] = new a1();
              } else if (aN === ah.KHR_MESH_QUANTIZATION) {
                aH[aN] = new a4();
              } else if (aO.indexOf(aN) >= 0 && aI[aN] === undefined) {
                console.warn(
                  'THREE.GLTFLoader: Unknown extension "' + aN + '".',
                );
              }
            }
          }
          aK.setExtensions(aH);
          aK.setPlugins(aI);
          aK.parse(aE, aF);
        }
      },
    });
    var ah = {
      KHR_BINARY_GLTF: "KHR_binary_glTF",
      KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
      KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
      KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
      KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
        "KHR_materials_pbrSpecularGlossiness",
      KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
      KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
      KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
      MSFT_TEXTURE_DDS: "MSFT_texture_dds",
    };
    Q.prototype.loadLight = function (aC) {
      var aD;
      var aE = this.lightDefs[aC];
      var aF = new THREE.Color(16777215);
      if (aE.color !== undefined) {
        aF.fromArray(aE.color);
      }
      var aG = aE.range === undefined ? 0 : aE.range;
      switch (aE.type) {
        case "directional":
          (aD = new THREE.DirectionalLight(aF)).target.position.set(0, 0, -1);
          aD.add(aD.target);
          break;
        case "point":
          (aD = new THREE.PointLight(aF)).distance = aG;
          break;
        case "spot":
          (aD = new THREE.SpotLight(aF)).distance = aG;
          aE.spot = aE.spot || {};
          aE.spot.innerConeAngle =
            aE.spot.innerConeAngle === undefined ? 0 : aE.spot.innerConeAngle;
          aE.spot.outerConeAngle =
            aE.spot.outerConeAngle === undefined
              ? Math.PI / 4
              : aE.spot.outerConeAngle;
          aD.angle = aE.spot.outerConeAngle;
          aD.penumbra = 1 - aE.spot.innerConeAngle / aE.spot.outerConeAngle;
          aD.target.position.set(0, 0, -1);
          aD.add(aD.target);
          break;
        default:
          throw new Error(
            'THREE.GLTFLoader: Unexpected light type, "' + aE.type + '".',
          );
      }
      aD.position.set(0, 0, 0);
      aD.decay = 2;
      if (aE.intensity !== undefined) {
        aD.intensity = aE.intensity;
      }
      aD.name = aE.name || "light_" + aC;
      return Promise.resolve(aD);
    };
    X.prototype.getMaterialType = function () {
      return THREE.MeshBasicMaterial;
    };
    X.prototype.extendParams = function (aC, aD, aE) {
      var aF = [];
      aC.color = new THREE.Color(1, 1, 1);
      aC.opacity = 1;
      var aG = aD.pbrMetallicRoughness;
      if (aG) {
        if (Array.isArray(aG.baseColorFactor)) {
          var aH = aG.baseColorFactor;
          aC.color.fromArray(aH);
          aC.opacity = aH[3];
        }
        if (aG.baseColorTexture !== undefined) {
          aF.push(aE.assignTexture(aC, "map", aG.baseColorTexture));
        }
      }
      return Promise.all(aF);
    };
    Y.prototype.getMaterialType = function () {
      return THREE.MeshPhysicalMaterial;
    };
    Y.prototype.extendMaterialParams = function (aC, aD) {
      var aE = this.parser;
      var aF = aE.json.materials[aC];
      if (!aF.extensions || !aF.extensions[this.name]) {
        return Promise.resolve();
      }
      var aG = [];
      var aH = aF.extensions[this.name];
      if (aH.clearcoatFactor !== undefined) {
        aD.clearcoat = aH.clearcoatFactor;
      }
      if (aH.clearcoatTexture !== undefined) {
        aG.push(aE.assignTexture(aD, "clearcoatMap", aH.clearcoatTexture));
      }
      if (aH.clearcoatRoughnessFactor !== undefined) {
        aD.clearcoatRoughness = aH.clearcoatRoughnessFactor;
      }
      if (aH.clearcoatRoughnessTexture !== undefined) {
        aG.push(
          aE.assignTexture(
            aD,
            "clearcoatRoughnessMap",
            aH.clearcoatRoughnessTexture,
          ),
        );
      }
      if (
        aH.clearcoatNormalTexture !== undefined &&
        (aG.push(
          aE.assignTexture(aD, "clearcoatNormalMap", aH.clearcoatNormalTexture),
        ),
        aH.clearcoatNormalTexture.scale !== undefined)
      ) {
        var aI = aH.clearcoatNormalTexture.scale;
        aD.clearcoatNormalScale = new THREE.Vector2(aI, aI);
      }
      return Promise.all(aG);
    };
    var ai = "glTF";
    var aj = {
      JSON: 1313821514,
      BIN: 5130562,
    };
    a0.prototype.decodePrimitive = function (aC, aD) {
      var aE = this.json;
      var aF = this.dracoLoader;
      var aG = aC.extensions[this.name].bufferView;
      var aH = aC.extensions[this.name].attributes;
      var aI = {};
      var aJ = {};
      var aK = {};
      for (var aL in aH) {
        var aM = av[aL] || aL.toLowerCase();
        aI[aM] = aH[aL];
      }
      for (aL in aC.attributes) {
        aM = av[aL] || aL.toLowerCase();
        if (aH[aL] !== undefined) {
          var aN = aE.accessors[aC.attributes[aL]];
          var aO = ar[aN.componentType];
          aK[aM] = aO;
          aJ[aM] = aN.normalized === true;
        }
      }
      return aD.getDependency("bufferView", aG).then(function (aP) {
        return new Promise(function (resolve) {
          aF.decodeDracoFile(
            aP,
            function (aR) {
              for (var aS in aR.attributes) {
                var aT = aR.attributes[aS];
                var aU = aJ[aS];
                if (aU !== undefined) {
                  aT.normalized = aU;
                }
              }
              resolve(aR);
            },
            aI,
            aK,
          );
        });
      });
    };
    a1.prototype.extendTexture = function (aC, aD) {
      aC = aC.clone();
      if (aD.offset !== undefined) {
        aC.offset.fromArray(aD.offset);
      }
      if (aD.rotation !== undefined) {
        aC.rotation = aD.rotation;
      }
      if (aD.scale !== undefined) {
        aC.repeat.fromArray(aD.scale);
      }
      if (aD.texCoord !== undefined) {
        console.warn(
          'THREE.GLTFLoader: Custom UV sets in "' +
            this.name +
            '" extension not yet supported.',
        );
      }
      aC.needsUpdate = true;
      return aC;
    };
    a2.prototype = Object.create(THREE.MeshStandardMaterial.prototype);
    a2.prototype.constructor = a2;
    a2.prototype.copy = function (aC) {
      THREE.MeshStandardMaterial.prototype.copy.call(this, aC);
      this.specularMap = aC.specularMap;
      this.specular.copy(aC.specular);
      this.glossinessMap = aC.glossinessMap;
      this.glossiness = aC.glossiness;
      delete this.metalness;
      delete this.roughness;
      delete this.metalnessMap;
      delete this.roughnessMap;
      return this;
    };
    a5.prototype = Object.create(THREE.Interpolant.prototype);
    a5.prototype.constructor = a5;
    a5.prototype.copySampleValue_ = function (aC) {
      var aD = this.resultBuffer;
      var aE = this.sampleValues;
      for (var aF = this.valueSize, aG = 0; aG !== aF; aG++) {
        aD[aG] = aE[aC * aF * 3 + aF + aG];
      }
      return aD;
    };
    a5.prototype.beforeStart_ = a5.prototype.copySampleValue_;
    a5.prototype.afterEnd_ = a5.prototype.copySampleValue_;
    a5.prototype.interpolate_ = function (aC, aD, aE, aF) {
      var aG = this.resultBuffer;
      var aH = this.sampleValues;
      for (
        var aI = this.valueSize,
          aJ = aI * 3,
          aK = aF - aD,
          aL = (aE - aD) / aK,
          aM = aL * aL,
          aN = aM * aL,
          aO = aC * aJ,
          aP = aO - aJ,
          aQ = aN * -2 + aM * 3,
          aR = aN - aM,
          aS = 0;
        aS !== aI;
        aS++
      ) {
        var aT = aH[aP + aS + aI];
        var aU = aH[aP + aS + aI * 2] * aK;
        var aV = aH[aO + aS + aI];
        var aW = aH[aO + aS] * aK;
        aG[aS] = (1 - aQ) * aT + (aR - aM + aL) * aU + aQ * aV + aR * aW;
      }
      return aG;
    };
    var ak = 0;
    var al = 1;
    var am = 2;
    var an = 3;
    var ao = 4;
    var ap = 5;
    var aq = 6;
    var ar = {
      5120: Int8Array,
      5121: Uint8Array,
      5122: Int16Array,
      5123: Uint16Array,
      5125: Uint32Array,
      5126: Float32Array,
    };
    var as = {
      9728: THREE.NearestFilter,
      9729: THREE.LinearFilter,
      9984: THREE.NearestMipmapNearestFilter,
      9985: THREE.LinearMipmapNearestFilter,
      9986: THREE.NearestMipmapLinearFilter,
      9987: THREE.LinearMipmapLinearFilter,
    };
    var at = {
      33071: THREE.ClampToEdgeWrapping,
      33648: THREE.MirroredRepeatWrapping,
      10497: THREE.RepeatWrapping,
    };
    var au = {
      SCALAR: 1,
      VEC2: 2,
      VEC3: 3,
      VEC4: 4,
      MAT2: 4,
      MAT3: 9,
      MAT4: 16,
    };
    var av = {
      POSITION: "position",
      NORMAL: "normal",
      TANGENT: "tangent",
      TEXCOORD_0: "uv",
      TEXCOORD_1: "uv2",
      COLOR_0: "color",
      WEIGHTS_0: "skinWeight",
      JOINTS_0: "skinIndex",
    };
    var aw = {
      scale: "scale",
      translation: "position",
      rotation: "quaternion",
      weights: "morphTargetInfluences",
    };
    var ax = {
      CUBICSPLINE: undefined,
      LINEAR: THREE.InterpolateLinear,
      STEP: THREE.InterpolateDiscrete,
    };
    var ay = "OPAQUE";
    var az = "MASK";
    var aA = "BLEND";
    var aB = {
      "image/png": THREE.RGBAFormat,
      "image/jpeg": THREE.RGBFormat,
    };
    ad.prototype.setExtensions = function (aC) {
      this.extensions = aC;
    };
    ad.prototype.setPlugins = function (aC) {
      this.plugins = aC;
    };
    ad.prototype.parse = function (aC, aD) {
      var aE = this;
      var aF = this.json;
      var aG = this.extensions;
      this.cache.removeAll();
      this.markDefs();
      Promise.all([
        this.getDependencies("scene"),
        this.getDependencies("animation"),
        this.getDependencies("camera"),
      ])
        .then(function (aH) {
          var aI = {
            scene: aH[0][aF.scene || 0],
            scenes: aH[0],
            animations: aH[1],
            cameras: aH[2],
            asset: aF.asset,
            parser: aE,
            userData: {},
          };
          a8(aG, aI, aF);
          a9(aI, aF);
          aC(aI);
        })
        .catch(aD);
    };
    ad.prototype.markDefs = function () {
      var aC;
      var aD = this.json.nodes || [];
      var aE = this.json.skins || [];
      var aF = this.json.meshes || [];
      var aG = {};
      var aH = {};
      for (var aI = 0, aJ = aE.length; aI < aJ; aI++) {
        for (var aK = 0, aL = (aC = aE[aI].joints).length; aK < aL; aK++) {
          aD[aC[aK]].isBone = true;
        }
      }
      var aM;
      for (var aN = 0, aO = aD.length; aN < aO; aN++) {
        if ((aM = aD[aN]).mesh !== undefined) {
          if (aG[aM.mesh] === undefined) {
            aG[aM.mesh] = aH[aM.mesh] = 0;
          }
          aG[aM.mesh]++;
          if (aM.skin !== undefined) {
            aF[aM.mesh].isSkinnedMesh = true;
          }
        }
      }
      this.json.meshReferences = aG;
      this.json.meshUses = aH;
    };
    ad.prototype._invokeOne = function (aC) {
      var aD = Object.values(this.plugins);
      aD.push(this);
      var aE;
      for (var aF = 0; aF < aD.length; aF++) {
        if ((aE = aC(aD[aF]))) {
          return aE;
        }
      }
    };
    ad.prototype._invokeAll = function (aC) {
      var aD = Object.values(this.plugins);
      aD.unshift(this);
      var aE = [];
      for (var aF = 0; aF < aD.length; aF++) {
        aE.push(aC(aD[aF]));
      }
      return Promise.all(aE);
    };
    ad.prototype.getDependency = function (aC, aD) {
      var aE = aC + ":" + aD;
      var aF = this.cache.get(aE);
      if (!aF) {
        switch (aC) {
          case "scene":
            aF = this.loadScene(aD);
            break;
          case "node":
            aF = this.loadNode(aD);
            break;
          case "mesh":
            aF = this._invokeOne(function (aG) {
              return aG.loadMesh && aG.loadMesh(aD);
            });
            break;
          case "accessor":
            aF = this.loadAccessor(aD);
            break;
          case "bufferView":
            aF = this._invokeOne(function (aG) {
              return aG.loadBufferView && aG.loadBufferView(aD);
            });
            break;
          case "buffer":
            aF = this.loadBuffer(aD);
            break;
          case "material":
            aF = this._invokeOne(function (aG) {
              return aG.loadMaterial && aG.loadMaterial(aD);
            });
            break;
          case "texture":
            aF = this.loadTexture(aD);
            break;
          case "skin":
            aF = this.loadSkin(aD);
            break;
          case "animation":
            aF = this.loadAnimation(aD);
            break;
          case "camera":
            aF = this.loadCamera(aD);
            break;
          case "light":
            aF = this.extensions[ah.KHR_LIGHTS_PUNCTUAL].loadLight(aD);
            break;
          default:
            throw new Error("Unknown type: " + aC);
        }
        this.cache.add(aE, aF);
      }
      return aF;
    };
    ad.prototype.getDependencies = function (aC) {
      var aD = this.cache.get(aC);
      if (!aD) {
        var aE = this;
        var aF = this.json[aC + (aC === "mesh" ? "es" : "s")] || [];
        aD = Promise.all(
          aF.map(function (aG, aH) {
            return aE.getDependency(aC, aH);
          }),
        );
        this.cache.add(aC, aD);
      }
      return aD;
    };
    ad.prototype.loadBuffer = function (aC) {
      var aD = this.json.buffers[aC];
      var aE = this.fileLoader;
      if (aD.type && aD.type !== "arraybuffer") {
        throw new Error(
          "THREE.GLTFLoader: " + aD.type + " buffer type is not supported.",
        );
      }
      if (aD.uri === undefined && aC === 0) {
        return Promise.resolve(this.extensions[ah.KHR_BINARY_GLTF].body);
      }
      var aF = this.options;
      return new Promise(function (resolve, reject) {
        aE.load(a6(aD.uri, aF.path), resolve, undefined, function () {
          reject(
            new Error(
              'THREE.GLTFLoader: Failed to load buffer "' + aD.uri + '".',
            ),
          );
        });
      });
    };
    ad.prototype.loadBufferView = function (aC) {
      var aD = this.json.bufferViews[aC];
      return this.getDependency("buffer", aD.buffer).then(function (aE) {
        var aF = aD.byteLength || 0;
        var aG = aD.byteOffset || 0;
        return aE.slice(aG, aG + aF);
      });
    };
    ad.prototype.loadAccessor = function (aC) {
      var aD = this;
      var aE = this.json;
      var aF = this.json.accessors[aC];
      if (aF.bufferView === undefined && aF.sparse === undefined) {
        return Promise.resolve(null);
      }
      var aG = [];
      if (aF.bufferView === undefined) {
        aG.push(null);
      } else {
        aG.push(this.getDependency("bufferView", aF.bufferView));
      }
      if (aF.sparse !== undefined) {
        aG.push(this.getDependency("bufferView", aF.sparse.indices.bufferView));
        aG.push(this.getDependency("bufferView", aF.sparse.values.bufferView));
      }
      return Promise.all(aG).then(function (aH) {
        var aI;
        var aJ;
        var aK = aH[0];
        var aL = au[aF.type];
        var aM = ar[aF.componentType];
        var aN = aM.BYTES_PER_ELEMENT;
        var aO = aF.byteOffset || 0;
        var aP =
          aF.bufferView === undefined
            ? undefined
            : aE.bufferViews[aF.bufferView].byteStride;
        var aQ = aF.normalized === true;
        if (aP && aP !== aN * aL) {
          var aR = Math.floor(aO / aP);
          var aS =
            "InterleavedBuffer:" +
            aF.bufferView +
            ":" +
            aF.componentType +
            ":" +
            aR +
            ":" +
            aF.count;
          var aT = aD.cache.get(aS);
          if (!aT) {
            aI = new aM(aK, aR * aP, (aF.count * aP) / aN);
            aT = new THREE.InterleavedBuffer(aI, aP / aN);
            aD.cache.add(aS, aT);
          }
          aJ = new THREE.InterleavedBufferAttribute(aT, aL, (aO % aP) / aN, aQ);
        } else {
          aI =
            aK === null ? new aM(aF.count * aL) : new aM(aK, aO, aF.count * aL);
          aJ = new THREE.BufferAttribute(aI, aL, aQ);
        }
        if (aF.sparse !== undefined) {
          var aU = au.SCALAR;
          var aV = ar[aF.sparse.indices.componentType];
          var aW = aF.sparse.indices.byteOffset || 0;
          var aX = aF.sparse.values.byteOffset || 0;
          var aY = new aV(aH[1], aW, aF.sparse.count * aU);
          var aZ = new aM(aH[2], aX, aF.sparse.count * aL);
          if (aK !== null) {
            aJ = new THREE.BufferAttribute(
              aJ.array.slice(),
              aJ.itemSize,
              aJ.normalized,
            );
          }
          var b0;
          for (var b1 = 0, b2 = aY.length; b1 < b2; b1++) {
            b0 = aY[b1];
            aJ.setX(b0, aZ[b1 * aL]);
            if (aL >= 2) {
              aJ.setY(b0, aZ[b1 * aL + 1]);
            }
            if (aL >= 3) {
              aJ.setZ(b0, aZ[b1 * aL + 2]);
            }
            if (aL >= 4) {
              aJ.setW(b0, aZ[b1 * aL + 3]);
            }
            if (aL >= 5) {
              throw new Error(
                "THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.",
              );
            }
          }
        }
        return aJ;
      });
    };
    ad.prototype.loadTexture = function (aC) {
      var aD;
      var aE = this;
      var aF = this.json;
      var aG = this.options;
      var aH = this.textureLoader;
      var aI = self.URL || self.webkitURL;
      var aJ = aF.textures[aC];
      var aK = aJ.extensions || {};
      var aL = (aD = aK[ah.MSFT_TEXTURE_DDS]
        ? aF.images[aK[ah.MSFT_TEXTURE_DDS].source]
        : aF.images[aJ.source]).uri;
      var aM = false;
      if (aD.bufferView !== undefined) {
        aL = aE.getDependency("bufferView", aD.bufferView).then(function (aN) {
          aM = true;
          var aO = new Blob([aN], {
            type: aD.mimeType,
          });
          return (aL = aI.createObjectURL(aO));
        });
      }
      return Promise.resolve(aL)
        .then(function (aN) {
          var aO = aG.manager.getHandler(aN);
          aO ||= aK[ah.MSFT_TEXTURE_DDS]
            ? aE.extensions[ah.MSFT_TEXTURE_DDS].ddsLoader
            : aH;
          return new Promise(function (resolve, reject) {
            var aR = resolve;
            if (aO.isImageBitmapLoader === true) {
              aR = function (aS) {
                resolve(new THREE.CanvasTexture(aS));
              };
            }
            aO.load(a6(aN, aG.path), aR, undefined, reject);
          });
        })
        .then(function (aN) {
          if (aM === true) {
            aI.revokeObjectURL(aL);
          }
          aN.flipY = false;
          if (aJ.name) {
            aN.name = aJ.name;
          }
          if (aD.mimeType in aB) {
            aN.format = aB[aD.mimeType];
          }
          var aO = (aF.samplers || {})[aJ.sampler] || {};
          aN.magFilter = as[aO.magFilter] || THREE.LinearFilter;
          aN.minFilter = as[aO.minFilter] || THREE.LinearMipmapLinearFilter;
          aN.wrapS = at[aO.wrapS] || THREE.RepeatWrapping;
          aN.wrapT = at[aO.wrapT] || THREE.RepeatWrapping;
          aE.associations.set(aN, {
            type: "textures",
            index: aC,
          });
          return aN;
        });
    };
    ad.prototype.assignTexture = function (aC, aD, aE) {
      var aF = this;
      return this.getDependency("texture", aE.index).then(function (aG) {
        if (!aG.isCompressedTexture) {
          if (
            aD === "aoMap" ||
            aD === "emissiveMap" ||
            aD === "metalnessMap" ||
            aD === "normalMap" ||
            aD === "roughnessMap"
          ) {
            aG.format = THREE.RGBFormat;
          }
        }
        if (
          aE.texCoord !== undefined &&
          aE.texCoord != 0 &&
          (aD !== "aoMap" || aE.texCoord != 1)
        ) {
          console.warn(
            "THREE.GLTFLoader: Custom UV set " +
              aE.texCoord +
              " for texture " +
              aD +
              " not yet supported.",
          );
        }
        if (aF.extensions[ah.KHR_TEXTURE_TRANSFORM]) {
          var aH =
            aE.extensions === undefined
              ? undefined
              : aE.extensions[ah.KHR_TEXTURE_TRANSFORM];
          if (aH) {
            var aI = aF.associations.get(aG);
            aG = aF.extensions[ah.KHR_TEXTURE_TRANSFORM].extendTexture(aG, aH);
            aF.associations.set(aG, aI);
          }
        }
        aC[aD] = aG;
      });
    };
    ad.prototype.assignFinalMaterial = function (aC) {
      var aD = aC.geometry;
      var aE = aC.material;
      var aF = aD.attributes.tangent !== undefined;
      var aG = aD.attributes.color !== undefined;
      var aH = aD.attributes.normal === undefined;
      var aI = aC.isSkinnedMesh === true;
      var aJ = Object.keys(aD.morphAttributes).length > 0;
      var aK = aJ && aD.morphAttributes.normal !== undefined;
      if (aC.isPoints) {
        var aL = "PointsMaterial:" + aE.uuid;
        var aM = this.cache.get(aL);
        if (!aM) {
          aM = new THREE.PointsMaterial();
          THREE.Material.prototype.copy.call(aM, aE);
          aM.color.copy(aE.color);
          aM.map = aE.map;
          aM.sizeAttenuation = false;
          this.cache.add(aL, aM);
        }
        aE = aM;
      } else if (aC.isLine) {
        aL = "LineBasicMaterial:" + aE.uuid;
        var aN = this.cache.get(aL);
        if (!aN) {
          aN = new THREE.LineBasicMaterial();
          THREE.Material.prototype.copy.call(aN, aE);
          aN.color.copy(aE.color);
          this.cache.add(aL, aN);
        }
        aE = aN;
      }
      if (aF || aG || aH || aI || aJ) {
        aL = "ClonedMaterial:" + aE.uuid + ":";
        if (aE.isGLTFSpecularGlossinessMaterial) {
          aL += "specular-glossiness:";
        }
        if (aI) {
          aL += "skinning:";
        }
        if (aF) {
          aL += "vertex-tangents:";
        }
        if (aG) {
          aL += "vertex-colors:";
        }
        if (aH) {
          aL += "flat-shading:";
        }
        if (aJ) {
          aL += "morph-targets:";
        }
        if (aK) {
          aL += "morph-normals:";
        }
        var aO = this.cache.get(aL);
        if (!aO) {
          aO = aE.clone();
          if (aI) {
            aO.skinning = true;
          }
          if (aF) {
            aO.vertexTangents = true;
          }
          if (aG) {
            aO.vertexColors = true;
          }
          if (aH) {
            aO.flatShading = true;
          }
          if (aJ) {
            aO.morphTargets = true;
          }
          if (aK) {
            aO.morphNormals = true;
          }
          this.cache.add(aL, aO);
          this.associations.set(aO, this.associations.get(aE));
        }
        aE = aO;
      }
      if (
        aE.aoMap &&
        aD.attributes.uv2 === undefined &&
        aD.attributes.uv !== undefined
      ) {
        aD.setAttribute("uv2", aD.attributes.uv);
      }
      if (aE.normalScale && !aF) {
        aE.normalScale.y = -aE.normalScale.y;
      }
      if (aE.clearcoatNormalScale && !aF) {
        aE.clearcoatNormalScale.y = -aE.clearcoatNormalScale.y;
      }
      aC.material = aE;
    };
    ad.prototype.getMaterialType = function () {
      return THREE.MeshStandardMaterial;
    };
    ad.prototype.loadMaterial = function (aC) {
      var aD;
      var aE = this;
      var aF = this.json;
      var aG = this.extensions;
      var aH = aF.materials[aC];
      var aI = {};
      var aJ = aH.extensions || {};
      var aK = [];
      if (aJ[ah.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
        var aL = aG[ah.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
        aD = aL.getMaterialType();
        aK.push(aL.extendParams(aI, aH, aE));
      } else if (aJ[ah.KHR_MATERIALS_UNLIT]) {
        var aM = aG[ah.KHR_MATERIALS_UNLIT];
        aD = aM.getMaterialType();
        aK.push(aM.extendParams(aI, aH, aE));
      } else {
        var aN = aH.pbrMetallicRoughness || {};
        aI.color = new THREE.Color(1, 1, 1);
        aI.opacity = 1;
        if (Array.isArray(aN.baseColorFactor)) {
          var aO = aN.baseColorFactor;
          aI.color.fromArray(aO);
          aI.opacity = aO[3];
        }
        if (aN.baseColorTexture !== undefined) {
          aK.push(aE.assignTexture(aI, "map", aN.baseColorTexture));
        }
        aI.metalness = aN.metallicFactor === undefined ? 1 : aN.metallicFactor;
        aI.roughness =
          aN.roughnessFactor === undefined ? 1 : aN.roughnessFactor;
        if (aN.metallicRoughnessTexture !== undefined) {
          aK.push(
            aE.assignTexture(aI, "metalnessMap", aN.metallicRoughnessTexture),
          );
          aK.push(
            aE.assignTexture(aI, "roughnessMap", aN.metallicRoughnessTexture),
          );
        }
        aD = this._invokeOne(function (aQ) {
          return aQ.getMaterialType && aQ.getMaterialType(aC);
        });
        aK.push(
          this._invokeAll(function (aQ) {
            return aQ.extendMaterialParams && aQ.extendMaterialParams(aC, aI);
          }),
        );
      }
      if (aH.doubleSided === true) {
        aI.side = THREE.DoubleSide;
      }
      var aP = aH.alphaMode || ay;
      if (aP === aA) {
        aI.transparent = true;
        aI.depthWrite = false;
      } else {
        aI.transparent = false;
        if (aP === az) {
          aI.alphaTest = aH.alphaCutoff === undefined ? 0.5 : aH.alphaCutoff;
        }
      }
      if (aH.normalTexture !== undefined && aD !== THREE.MeshBasicMaterial) {
        aK.push(aE.assignTexture(aI, "normalMap", aH.normalTexture));
        aI.normalScale = new THREE.Vector2(1, 1);
        if (aH.normalTexture.scale !== undefined) {
          aI.normalScale.set(aH.normalTexture.scale, aH.normalTexture.scale);
        }
      }
      if (aH.occlusionTexture !== undefined && aD !== THREE.MeshBasicMaterial) {
        aK.push(aE.assignTexture(aI, "aoMap", aH.occlusionTexture));
        if (aH.occlusionTexture.strength !== undefined) {
          aI.aoMapIntensity = aH.occlusionTexture.strength;
        }
      }
      if (aH.emissiveFactor !== undefined && aD !== THREE.MeshBasicMaterial) {
        aI.emissive = new THREE.Color().fromArray(aH.emissiveFactor);
      }
      if (aH.emissiveTexture !== undefined && aD !== THREE.MeshBasicMaterial) {
        aK.push(aE.assignTexture(aI, "emissiveMap", aH.emissiveTexture));
      }
      return Promise.all(aK).then(function () {
        var aQ;
        aQ =
          aD === a2
            ? aG[ah.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(aI)
            : new aD(aI);
        if (aH.name) {
          aQ.name = aH.name;
        }
        if (aQ.map) {
          aQ.map.encoding = THREE.sRGBEncoding;
        }
        if (aQ.emissiveMap) {
          aQ.emissiveMap.encoding = THREE.sRGBEncoding;
        }
        a9(aQ, aH);
        aE.associations.set(aQ, {
          type: "materials",
          index: aC,
        });
        if (aH.extensions) {
          a8(aG, aQ, aH);
        }
        return aQ;
      });
    };
    ad.prototype.loadGeometries = function (aC) {
      function aD(aO) {
        return aF[ah.KHR_DRACO_MESH_COMPRESSION]
          .decodePrimitive(aO, aE)
          .then(function (aP) {
            return af(aP, aO, aE);
          });
      }
      var aE = this;
      var aF = this.extensions;
      var aG = this.primitiveCache;
      var aH = [];
      for (var aI = 0, aJ = aC.length; aI < aJ; aI++) {
        var aK;
        var aL = aC[aI];
        var aM = ab(aL);
        var aN = aG[aM];
        if (aN) {
          aH.push(aN.promise);
        } else {
          aK =
            aL.extensions && aL.extensions[ah.KHR_DRACO_MESH_COMPRESSION]
              ? aD(aL)
              : af(new THREE.BufferGeometry(), aL, aE);
          aG[aM] = {
            primitive: aL,
            promise: aK,
          };
          aH.push(aK);
        }
      }
      return Promise.all(aH);
    };
    ad.prototype.loadMesh = function (aC) {
      var aD;
      var aE = this;
      var aF = this.json.meshes[aC];
      var aG = aF.primitives;
      var aH = [];
      for (var aI = 0, aJ = aG.length; aI < aJ; aI++) {
        aD =
          aG[aI].material === undefined
            ? a7(this.cache)
            : this.getDependency("material", aG[aI].material);
        aH.push(aD);
      }
      aH.push(aE.loadGeometries(aG));
      return Promise.all(aH).then(function (aK) {
        var aL = aK.slice(0, aK.length - 1);
        var aM = aK[aK.length - 1];
        var aN = [];
        for (var aO = 0, aP = aM.length; aO < aP; aO++) {
          var aQ;
          var aR = aM[aO];
          var aS = aG[aO];
          var aT = aL[aO];
          if (
            aS.mode === ao ||
            aS.mode === ap ||
            aS.mode === aq ||
            aS.mode === undefined
          ) {
            if (
              (aQ =
                aF.isSkinnedMesh === true
                  ? new THREE.SkinnedMesh(aR, aT)
                  : new THREE.Mesh(aR, aT)).isSkinnedMesh === true &&
              !aQ.geometry.attributes.skinWeight.normalized
            ) {
              aQ.normalizeSkinWeights();
            }
            if (aS.mode === ap) {
              aQ.geometry = ag(aQ.geometry, THREE.TriangleStripDrawMode);
            } else if (aS.mode === aq) {
              aQ.geometry = ag(aQ.geometry, THREE.TriangleFanDrawMode);
            }
          } else if (aS.mode === al) {
            aQ = new THREE.LineSegments(aR, aT);
          } else if (aS.mode === an) {
            aQ = new THREE.Line(aR, aT);
          } else if (aS.mode === am) {
            aQ = new THREE.LineLoop(aR, aT);
          } else {
            if (aS.mode !== ak) {
              throw new Error(
                "THREE.GLTFLoader: Primitive mode unsupported: " + aS.mode,
              );
            }
            aQ = new THREE.Points(aR, aT);
          }
          if (Object.keys(aQ.geometry.morphAttributes).length > 0) {
            aa(aQ, aF);
          }
          aQ.name = aF.name || "mesh_" + aC;
          if (aM.length > 1) {
            aQ.name += "_" + aO;
          }
          a9(aQ, aF);
          aE.assignFinalMaterial(aQ);
          aN.push(aQ);
        }
        if (aN.length === 1) {
          return aN[0];
        }
        var aU = new THREE.Group();
        aO = 0;
        aP = aN.length;
        for (; aO < aP; aO++) {
          aU.add(aN[aO]);
        }
        return aU;
      });
    };
    ad.prototype.loadCamera = function (aC) {
      var aD;
      var aE = this.json.cameras[aC];
      var aF = aE[aE.type];
      if (aF) {
        if (aE.type === "perspective") {
          aD = new THREE.PerspectiveCamera(
            THREE.MathUtils.radToDeg(aF.yfov),
            aF.aspectRatio || 1,
            aF.znear || 1,
            aF.zfar || 2000000,
          );
        } else if (aE.type === "orthographic") {
          aD = new THREE.OrthographicCamera(
            -aF.xmag,
            aF.xmag,
            aF.ymag,
            -aF.ymag,
            aF.znear,
            aF.zfar,
          );
        }
        if (aE.name) {
          aD.name = aE.name;
        }
        a9(aD, aE);
        return Promise.resolve(aD);
      } else {
        console.warn("THREE.GLTFLoader: Missing camera parameters.");
        return;
      }
    };
    ad.prototype.loadSkin = function (aC) {
      var aD = this.json.skins[aC];
      var aE = {
        joints: aD.joints,
      };
      if (aD.inverseBindMatrices === undefined) {
        return Promise.resolve(aE);
      } else {
        return this.getDependency("accessor", aD.inverseBindMatrices).then(
          function (aF) {
            aE.inverseBindMatrices = aF;
            return aE;
          },
        );
      }
    };
    ad.prototype.loadAnimation = function (aC) {
      var aD = this.json.animations[aC];
      var aE = [];
      var aF = [];
      var aG = [];
      var aH = [];
      var aI = [];
      for (var aJ = 0, aK = aD.channels.length; aJ < aK; aJ++) {
        var aL = aD.channels[aJ];
        var aM = aD.samplers[aL.sampler];
        var aN = aL.target;
        var aO = aN.node === undefined ? aN.id : aN.node;
        var aP =
          aD.parameters === undefined ? aM.input : aD.parameters[aM.input];
        var aQ =
          aD.parameters === undefined ? aM.output : aD.parameters[aM.output];
        aE.push(this.getDependency("node", aO));
        aF.push(this.getDependency("accessor", aP));
        aG.push(this.getDependency("accessor", aQ));
        aH.push(aM);
        aI.push(aN);
      }
      return Promise.all([
        Promise.all(aE),
        Promise.all(aF),
        Promise.all(aG),
        Promise.all(aH),
        Promise.all(aI),
      ]).then(function (aR) {
        var aS = aR[0];
        var aT = aR[1];
        var aU = aR[2];
        var aV = aR[3];
        var aW = aR[4];
        var aX = [];
        for (var aY = 0, aZ = aS.length; aY < aZ; aY++) {
          var b0 = aS[aY];
          var b1 = aT[aY];
          var b2 = aU[aY];
          var b3 = aV[aY];
          var b4 = aW[aY];
          if (b0 !== undefined) {
            var b5;
            b0.updateMatrix();
            b0.matrixAutoUpdate = true;
            switch (aw[b4.path]) {
              case aw.weights:
                b5 = THREE.NumberKeyframeTrack;
                break;
              case aw.rotation:
                b5 = THREE.QuaternionKeyframeTrack;
                break;
              case aw.position:
              case aw.scale:
              default:
                b5 = THREE.VectorKeyframeTrack;
            }
            var b6 = b0.name ? b0.name : b0.uuid;
            var b7 =
              b3.interpolation === undefined
                ? THREE.InterpolateLinear
                : ax[b3.interpolation];
            var b8 = [];
            if (aw[b4.path] === aw.weights) {
              b0.traverse(function (bg) {
                if (bg.isMesh === true && bg.morphTargetInfluences) {
                  b8.push(bg.name ? bg.name : bg.uuid);
                }
              });
            } else {
              b8.push(b6);
            }
            var b9 = b2.array;
            if (b2.normalized) {
              var ba;
              if (b9.constructor === Int8Array) {
                ba = 1 / 127;
              } else if (b9.constructor === Uint8Array) {
                ba = 1 / 255;
              } else if (b9.constructor == Int16Array) {
                ba = 1 / 32767;
              } else {
                if (b9.constructor !== Uint16Array) {
                  throw new Error(
                    "THREE.GLTFLoader: Unsupported output accessor component type.",
                  );
                }
                ba = 1 / 65535;
              }
              var bb = new Float32Array(b9.length);
              for (var bc = 0, bd = b9.length; bc < bd; bc++) {
                bb[bc] = b9[bc] * ba;
              }
              b9 = bb;
            }
            var be;
            bc = 0;
            bd = b8.length;
            for (; bc < bd; bc++) {
              be = new b5(b8[bc] + "." + aw[b4.path], b1.array, b9, b7);
              if (b3.interpolation === "CUBICSPLINE") {
                be.createInterpolant = function (bg) {
                  return new a5(
                    this.times,
                    this.values,
                    this.getValueSize() / 3,
                    bg,
                  );
                };
                be.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
              }
              aX.push(be);
            }
          }
        }
        var bf = aD.name ? aD.name : "animation_" + aC;
        return new THREE.AnimationClip(bf, undefined, aX);
      });
    };
    ad.prototype.loadNode = function (aC) {
      var aD = this.json;
      var aE = this.extensions;
      var aF = this;
      var aG = aD.meshReferences;
      var aH = aD.meshUses;
      var aI = aD.nodes[aC];
      return (function () {
        var aJ = [];
        if (aI.mesh !== undefined) {
          aJ.push(
            aF.getDependency("mesh", aI.mesh).then(function (aK) {
              var aL;
              if (aG[aI.mesh] > 1) {
                var aM = aH[aI.mesh]++;
                (aL = aK.clone()).name += "_instance_" + aM;
              } else {
                aL = aK;
              }
              if (aI.weights !== undefined) {
                aL.traverse(function (aN) {
                  if (aN.isMesh) {
                    for (var aO = 0, aP = aI.weights.length; aO < aP; aO++) {
                      aN.morphTargetInfluences[aO] = aI.weights[aO];
                    }
                  }
                });
              }
              return aL;
            }),
          );
        }
        if (aI.camera !== undefined) {
          aJ.push(aF.getDependency("camera", aI.camera));
        }
        if (
          aI.extensions &&
          aI.extensions[ah.KHR_LIGHTS_PUNCTUAL] &&
          aI.extensions[ah.KHR_LIGHTS_PUNCTUAL].light !== undefined
        ) {
          aJ.push(
            aF.getDependency(
              "light",
              aI.extensions[ah.KHR_LIGHTS_PUNCTUAL].light,
            ),
          );
        }
        return Promise.all(aJ);
      })().then(function (aJ) {
        var aK;
        if (
          (aK =
            aI.isBone === true
              ? new THREE.Bone()
              : aJ.length > 1
                ? new THREE.Group()
                : aJ.length === 1
                  ? aJ[0]
                  : new THREE.Object3D()) !== aJ[0]
        ) {
          for (var aL = 0, aM = aJ.length; aL < aM; aL++) {
            aK.add(aJ[aL]);
          }
        }
        if (aI.name) {
          aK.userData.name = aI.name;
          aK.name = THREE.PropertyBinding.sanitizeNodeName(aI.name);
        }
        a9(aK, aI);
        if (aI.extensions) {
          a8(aE, aK, aI);
        }
        if (aI.matrix !== undefined) {
          var aN = new THREE.Matrix4();
          aN.fromArray(aI.matrix);
          aK.applyMatrix4(aN);
        } else {
          if (aI.translation !== undefined) {
            aK.position.fromArray(aI.translation);
          }
          if (aI.rotation !== undefined) {
            aK.quaternion.fromArray(aI.rotation);
          }
          if (aI.scale !== undefined) {
            aK.scale.fromArray(aI.scale);
          }
        }
        aF.associations.set(aK, {
          type: "nodes",
          index: aC,
        });
        return aK;
      });
    };
    ad.prototype.loadScene = (function () {
      function aC(aD, aE, aF, aG) {
        var aH = aF.nodes[aD];
        return aG
          .getDependency("node", aD)
          .then(function (aI) {
            if (aH.skin === undefined) {
              return aI;
            } else {
              return aG
                .getDependency("skin", aH.skin)
                .then(function (aK) {
                  var aL = [];
                  for (
                    var aM = 0, aN = (aJ = aK).joints.length;
                    aM < aN;
                    aM++
                  ) {
                    aL.push(aG.getDependency("node", aJ.joints[aM]));
                  }
                  return Promise.all(aL);
                })
                .then(function (aK) {
                  aI.traverse(function (aL) {
                    if (aL.isMesh) {
                      var aM;
                      var aN = [];
                      var aO = [];
                      var aP = 0;
                      for (aK.length; aP < undefined; aP++) {
                        if ((aM = aK[aP])) {
                          aN.push(aM);
                          var aQ = new THREE.Matrix4();
                          if (aJ.inverseBindMatrices !== undefined) {
                            aQ.fromArray(aJ.inverseBindMatrices.array, aP * 16);
                          }
                          aO.push(aQ);
                        } else {
                          console.warn(
                            'THREE.GLTFLoader: Joint "%s" could not be found.',
                            aJ.joints[aP],
                          );
                        }
                      }
                      aL.bind(new THREE.Skeleton(aN, aO), aL.matrixWorld);
                    }
                  });
                  return aI;
                });
            }
            var aJ;
          })
          .then(function (aI) {
            aE.add(aI);
            var aJ = [];
            if (aH.children) {
              var aK;
              var aL = aH.children;
              for (var aM = 0, aN = aL.length; aM < aN; aM++) {
                aK = aL[aM];
                aJ.push(aC(aK, aI, aF, aG));
              }
            }
            return Promise.all(aJ);
          });
      }
      return function (aD) {
        var aE = this.json;
        var aF = this.extensions;
        var aG = this.json.scenes[aD];
        var aH = new THREE.Group();
        if (aG.name) {
          aH.name = aG.name;
        }
        a9(aH, aG);
        if (aG.extensions) {
          a8(aF, aH, aG);
        }
        var aI = aG.nodes || [];
        var aJ = [];
        for (var aK = 0, aL = aI.length; aK < aL; aK++) {
          aJ.push(aC(aI[aK], aH, aE, this));
        }
        return Promise.all(aJ).then(function () {
          return aH;
        });
      };
    })();
    return q;
  })();
};
